import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';

import EventInfoCard from './EventInfoCard';
import StartNumberSearch from './StartNumberSearch';
import ExtendedSearch from '../extended-search/ExtendedSearch';

class EventOnlineView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startNumber: props.urlSn || '',
      secondFactor: props.customerKey ? window.atob(props.customerKey) : '',
    };
  }

  handleInputChange = (name, value) => {
    this.setState({ [name]: value });
  };

  render() {
    const {
      onlineEvent,
      onExpandBestof,
      bestOfAvailable,
      extendedSearchSelectedCategoryId,
      showSearchInstructionsDialog,
      extendedSearchSelectedTab,
      extendedSearchExpand,
      onExtendedSearchTabChange,
      onExtendedSearchExpand,
      hasSmartSearchTab,
      hasCategorySearchTab,
      hasGpsSearchTab,
      hasFaceSearchTab,
      hasExtendedSearch,
      onSearchTrigger,
      urlSn,
    } = this.props;

    const { startNumber, secondFactor } = this.state;

    return (
      <div>
        <div className="row">
          <EventInfoCard
            eventInfo={onlineEvent}
            onExpandBestof={onExpandBestof}
            bestOfAvailable={bestOfAvailable}
            eventBannerActAsLink={true}
          />
          <StartNumberSearch
            info={onlineEvent}
            onInputChange={this.handleInputChange}
            onSearchTrigger={onSearchTrigger}
            startNumber={startNumber}
            secondFactor={secondFactor}
            showSearchInstructionsDialog={showSearchInstructionsDialog}
          />
        </div>
        {/**
         * If `hasExtendedSearch` is true the extended search options will only be displayed
         */}
        {hasExtendedSearch && (
          <ExtendedSearch
            startnumber={startNumber}
            event={onlineEvent}
            selectedCategoryId={extendedSearchSelectedCategoryId}
            selectedTab={extendedSearchSelectedTab}
            expand={extendedSearchExpand}
            onTabChange={onExtendedSearchTabChange}
            onExpand={onExtendedSearchExpand}
            hasSmartSearchTab={hasSmartSearchTab}
            hasCategorySearchTab={hasCategorySearchTab}
            hasGpsSearchTab={hasGpsSearchTab}
            hasFaceSearchTab={hasFaceSearchTab}
          />
        )}
      </div>
    );
  }
}

EventOnlineView.defaultProps = {
  hasExtendedSearch: true,
};

EventOnlineView.propTypes = {
  extendedSearchSelectedCategoryId: PropTypes.string,
  urlSn: PropTypes.string,
  customerKey: PropTypes.string,
  bestOfAvailable: PropTypes.bool,
  extendedSearchExpand: PropTypes.bool,
  hasSmartSearchTab: PropTypes.bool,
  hasCategorySearchTab: PropTypes.bool,
  hasGpsSearchTab: PropTypes.bool,
  hasFaceSearchTab: PropTypes.bool,
  hasExtendedSearch: PropTypes.bool,
  showSearchInstructionsDialog: PropTypes.bool,
  extendedSearchSelectedTab: PropTypes.number,
  onlineEvent: PropTypes.object,
  onExpandBestof: PropTypes.func,
  onExtendedSearchTabChange: PropTypes.func,
  onExtendedSearchExpand: PropTypes.func,
  onSearchTrigger: PropTypes.func,
};

export { EventOnlineView };

export default createFragmentContainer(EventOnlineView, {
  onlineEvent: graphql`
    fragment EventOnlineView_onlineEvent on Event {
      id
      sgId
      hostResultUrl
      ...EventInfoCard_eventInfo
      ...StartNumberSearch_info
      ...ExtendedSearch_event
    }
  `,
});
